<div class="row col-12 editor-container">
  <div class="col-6 mobile-setting-container">
    <div class="mobile-card" [ngClass]="{'card-disabled': isVideoPlaylist}">
      <div>@if (!isViewerMode) {
        <span class="mobile-settings">Mobile Settings</span>
      }
      @if (isViewerMode) {
        <span class="mobile-settings">
          <i>Mobile Settings are only available in Edit Mode</i>
        </span>
      }
      <hr class="divider-margin" />
    </div>
    <div [ngClass]="{'div-disabled': isViewerMode}">
      <label style="font-size: 16px; padding-left: 5px;"
        class="custom__checkmark control-label collapse-header collapsed" data-bs-toggle="collapse"
        data-bs-target="#collapseExample1" aria-expanded="false">
        <span class="material-icons arrow-bottom collapse-arrow"
        style="position: relative;top: 6px;">arrow_left</span>
        Reorder Content Frames
      </label>
      <div class="collapse" id="collapseExample1" style="padding: 0px 34px;">
        <span class="info-span">
          <i>
            Click the button below to drag and drop content frames to a new position on mobile. No other editing
            options will be enabled while the Reorder button is active.
          </i>
        </span>
        <div class="text-center">
          @if (!reorderContent) {
            <button style="font-size: 14px;" class="btn vPlaybookDefaultButton btn__btn-default"
            (click)="reorderContentFunc()">Reorder Content</button>
          }
          @if (reorderContent) {
            <button style="font-size: 14px;" class="btn btn__orange btn__btn-default"
            (click)="reorderContentFunc()">Done</button>
          }
        </div>
      </div>
      <hr class="divider-margin" />
    </div>
    <div [ngClass]="{'div-disabled': isViewerMode}">
      <label style="font-size: 16px; padding-left: 5px;"
        class="custom__checkmark control-label collapse-header collapsed" data-bs-toggle="collapse"
        data-bs-target="#collapseExample2" aria-expanded="false">
        <span class="material-icons arrow-bottom collapse-arrow"
        style="position: relative;top: 6px;">arrow_left</span>
        Show/Hide Content
      </label>
      <div class="collapse" id="collapseExample2" style="padding: 0px 34px;">
        <span class="info-span">
          <i>
            Click the button below to to hide or revealcontent on mobile. Content blocks with a checkmark will appear
            on mobile. To hide content, click the checkmark to toggle the content to "hidden".
          </i>
        </span>
        <div class="text-center">
          @if (!hideContent) {
            <button style="font-size: 14px;" class="btn vPlaybookDefaultButton btn__btn-default"
            (click)="hidePlaybookContents()">Show/Hide Content</button>
          }
          @if (hideContent) {
            <button style="font-size: 14px;" class="btn btn__orange btn__btn-default"
            (click)="hidePlaybookContents()">Done</button>
          }
        </div>
      </div>
      <hr class="divider-margin" />
    </div>
    <div [ngClass]="{'div-disabled': isViewerMode}">
      <label style="font-size: 16px; padding-left: 5px;"
        class="custom__checkmark control-label collapse-header collapsed" data-bs-toggle="collapse"
        data-bs-target="#collapseExample3" aria-expanded="false">
        <span class="material-icons arrow-bottom collapse-arrow"
        style="position: relative;top: 6px;">arrow_left</span>
        Footer Menu
      </label>
      <div class="collapse" id="collapseExample3" style="padding: 0px 34px;">
        <span class="info-span">
          <i>
            Select up to 4 options below to customize the icons in the footer toolbar. This is a global setting for
            this playbook. Any changes made on this page will be present throughtout this playbook.
          </i>
        </span>
        <div class="row">
          <table class="table popup-table">
            <tbody cdkDropList (cdkDropListDropped)="drop($event)">
            </tbody>
          </table>
        </div>
        <div class="text-end" style="margin-bottom: 10px;">
          <button type="button" (click)="saveFooterMenus()" class="btn btn__btn-default btn__orange">Save
          Menus</button>
        </div>
      </div>
    </div>
    <hr class="divider-margin">
    <div class="preview_button">
      <button type="button" (click)="changeViewerMode()" class="btn btn__btn-default btn__orange"
        [ngClass]="{'card-disabled': isVideoPlaylist}" [disabled]="isVideoPlaylist">{{isPreviewMode ?
      'Show Editor Mode' :'Show Viewer Mode'}} </button>
    </div>
  </div>
</div>
<div class="col-6 mobile-viewer-container">
  <div class="mobile-device note8">
    <div class="inner"></div>
    <div class="speaker"></div>
    <div class="more-sensors"></div>
    <div class="sleep"></div>
    <div class="volume"></div>
    <div class="camera"></div>
    <div class="screen">
      <iframe id="frameId" style="width: 350px; height: 100%;" [src]="url | safe:'resourceUrl'">
      </iframe>
    </div>
  </div>
</div>
</div>